module.exports = __webpack_public_path__ + "540b4dd6567feed5fdda5c7f624f3bb4.svg";